// ABOUTME: Configuration for the warehouse Email settings page.
// ABOUTME: One tab per customizable email template type, plus a general email settings tab (always last).

import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

export const emailConfig = {
    notification: {
        title: 'notifications_email',
        icon: <EmailOutlinedIcon />,
    },
    purchaseorder: {
        title: 'purchaseorder_email',
        icon: <EmailOutlinedIcon />,
    },
    settings: {
        title: 'email_settings',
        icon: <SettingsOutlinedIcon />,
    },
};
